import SelectableFieldsController from './selectable-fields-controller';

export default class extends SelectableFieldsController {
  static targets = ['radioButton', 'fieldSet'];

  //
  // GETTERS AND SETTERS
  //

  get selectedValue() {
    const selectedElement = this.radioButtonTargets.find(el => el.checked);
    return selectedElement ? selectedElement.value : null;
  }
};



// WEBPACK FOOTER //
// ./app/components/forms/fields/assets/javascript/fields-radio-button-controller.js